import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";
import React, { Component } from "react";

/**
 * @param code - код.
 * @param props.onClose - событие закрытия окна диалога.
 */

class CodeNotFoundDialog extends Component {
    render() {
        return <Dialog open>
            <DialogTitle>Ошибка</DialogTitle>
            <DialogContent>
                Код {this.props.code} не найден в базе данных.
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={e => {
                        e.stopPropagation()
                        this.props.onClose()
                    }}
                >
                    Закрыть
                </Button>
            </DialogActions>
        </Dialog>
    }
}

export default CodeNotFoundDialog